export const SystemOptionsActionConstants = {
    SET_CURRENCIES: 'SET_CURRENCIES',
    ADD_CURRENCY: 'ADD_CURRENCY',
    UPDATE_CURRENCY: 'UPDATE_CURRENCY',
    DELETE_CURRENCY: 'DELETE_CURRENCY',
    STORE_CURRENCIES: 'STORE_CURRENCIES',
    FETCH_CURRENCIES: 'FETCH_CURRENCIES',
}